import './mask-field-list-translated-string.scss'

import { defineComponent, PropType } from 'vue'
import _ from 'lodash';
import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons'

import { EntityField, EntityFieldStatus, createTranslatedString } from '@skinsoft/types';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { MaskFieldText } from '../mask-field-text';
import { MaskFieldUpdateEvent, MaskFieldUpdateEventType } from '../mask-field';

export const MaskFieldListTranslatedString = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sMaskFieldText: MaskFieldText,
    },
    props: {
        entityField: {
            type: Object as PropType<EntityField>,
            required: true,
        },
        fieldValue: {
            type: Array as PropType<any[] | null>,
        },
        editing: {
            type: Boolean,
        },
        getStatus: {
            type: Function as PropType<(entityField: EntityField) => EntityFieldStatus>,
            required: true,
        },
        dataCy: {
            type: String,
        },
    },
    template: require('./mask-field-list-translated-string.html'),
    data() {
        return {
            trashIcon: faTrash,
            addIcon: faPlusCircle,
            values: [] as any[],
        }
    },
    mounted() {
        this.values = this.fieldValue ?? []
    },
    methods: {
        updateChangeEvent(event: MaskFieldUpdateEvent, index: number) {
            let updatedEvent: MaskFieldUpdateEvent = {...event}

            updatedEvent.fieldPath = updatedEvent.fieldPath.replace(
                `${this.entityField.path}`,
                `${this.entityField.path}.${index}`
            )

            this.$emit("value-change", updatedEvent)
        },
        onDeleteClick(index: number) {
            const path = `${this.entityField.path}[${index}]`

            this.$emit(
                'value-change',
                {
                    abstractEntity: this.entityField.abstractEntity,
                    fieldPath: path,
                    value: null,
                    type: MaskFieldUpdateEventType.DELETE,
                } as MaskFieldUpdateEvent
            )
        },
        getEntityField(): EntityField {
            let result = _.cloneDeep(this.entityField)
            result.type.type = "TranslatedString"
            return result
        },
        isReadonly(entityField: EntityField) {
            return entityField.isReadOnly || this.getStatus(entityField).disabled
        },
        infoMessage(entityField: EntityField): string | undefined {
            return this.getStatus(entityField).disabledMessage
        },
        errorMessage(entityField: EntityField): string | undefined {
            return this.getStatus(entityField).errorMessage
        },
        hasError(entityField: EntityField) {
            return this.getStatus(entityField).error
        },
        getDataCy(index?: number): String {
            let res: string = this.entityField.path
            if(this.dataCy) {
                res = this.dataCy
            }
            if(index !== undefined && index !== null) {
                res = `${res}.${index}`
            }

            return res
        },
    },
    watch: {
        fieldValue() {
            this.values = this.fieldValue ?? []
        },
    },
})
